<template>
  <div>
    <p>
      <v-btn :to="documentEntityLink">
        <v-icon>chevron_left</v-icon>Change entities
      </v-btn>
    </p>
    <h1>Choose templates</h1>
    <FileWorking :file="file" />
    <v-card v-if="entities" class="entities">
      <v-card-text>
        <strong>Concerning:</strong>
        <EntityZ v-for="entity in entities" :key="entity.id" :entity="entity" />
      </v-card-text>
    </v-card>
    <v-alert :value="true" type="info">
      <div>
        Please select below the templates you wish to generate by clicking the
        checkbox or row. Holding the CTRL button will allow multiple templates
        to be selected. Hold SHIFT to select contiguously. Then click the button
        at the bottom of the page.
      </div>
      <div
        v-if="
          $route.params.entityTypeId == 3 || $route.params.entityTypeId == 4
        "
      >
        Click 'select opening letters' to select a set of common opening
        letters.
      </div>
    </v-alert>
    <div v-if="file && file.departmentId == 7">
      <v-btn
        @click="selectOpeningLetters"
        v-if="
          $route.params.entityTypeId == 3 || $route.params.entityTypeId == 4
        "
      >
        <v-icon>check_circle</v-icon>Select opening letters
      </v-btn>
    </div>
    <v-list subheader>
      <v-subheader>Templates</v-subheader>
      <v-list-tile v-for="template in templates" :key="template.id">
        <v-list-tile-action>
          <v-checkbox v-model="selectedTemplates" :value="template.id" />
        </v-list-tile-action>
        <v-list-tile-content @click="toggleTemplate(template)">
          <v-list-tile-title>{{ template.code }}</v-list-tile-title>
          <v-list-tile-sub-title>{{ template.name }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-list>
      <v-subheader>Common uploads</v-subheader>
      <v-list-tile v-for="upload in uploadsCommon" :key="upload.id">
        <v-list-tile-action>
          <v-checkbox v-model="selectedUploads" :value="upload.id" />
        </v-list-tile-action>
        <v-list-tile-content @click="toggleUpload(upload)">
          <v-list-tile-title>
            <span v-if="upload.uploadDescription">{{
              upload.uploadDescription.body
            }}</span>
            <span v-if="!upload.uploadDescription">No description!</span>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-btn @click="navigate">
      Continue
      <v-icon>chevron_right</v-icon>
    </v-btn>
    <v-alert :value="feedback" type="error">{{ feedback }}</v-alert>
  </div>
</template>

<script>
import UPLOADS_COMMON from "@/graphql/document/UploadsCommon";
import EntityZ from "@/components/link/EntityZ";
import FileWorking from "@/components/link/FileWorking";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "DocumentTemplate",
  metaInfo() {
    return {
      title: "Document template",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    uploadsCommon: {
      query: UPLOADS_COMMON,
      variables() {
        return {
          archived: false
        };
      },
      fetchPolicy: "cache-and-network"
    }
  },
  components: {
    EntityZ,
    FileWorking
  },
  computed: {
    documentEntityLink() {
      return {
        name: "documentEntity",
        params: {
          objectType: this.$route.params.objectType,
          objectId: this.$route.params.objectId,
          entityTypeId: this.$route.params.entityTypeId
        }
      };
    }
  },
  data() {
    return {
      entities: null,
      file: null,
      templates: null,
      descriptions: null,
      feedback: null,
      selectedUploads: [],
      selectedTemplates: []
    };
  },
  methods: {
    async fetchEntities() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/entities/multiple/${this.$route.params.entities}`
      );
      // console.log(response.data);
      this.entities = response.data;
    },
    async fetchFile() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.objectId}`
      );
      // console.log(response.data);
      this.file = response.data;
    },
    async fetchTemplates() {
      const response = await nbmlaw.get(
        `/cors/admin/file/files/${this.$route.params.objectId}/templates/filtered/${this.$route.params.entityTypeId}`
      );
      // console.log(response.data);
      this.templates = response.data;
    },
    selectOpeningLetters() {
      const openingLetters = [1, 9, 10, 14, 22, 23, 24, 120, 228];
      this.selectedTemplates = this.templates
        .map((t) => t.id)
        .filter((t) => openingLetters.includes(t));
    },
    navigate() {
      if (this.selectedTemplates.length == 0) {
        //check something is selected
        this.feedback = "You need to select at least one template";
        return;
      }
      //join template ids with dot
      const templates = this.selectedTemplates.join(".");
      //join upload ids with dot
      const uploads = this.selectedUploads.join(".");
      //redirectUri
      this.redirect(templates, uploads);
    },
    redirect(templates, uploads) {
      const params = {
        objectType: this.$route.params.objectType,
        objectId: this.$route.params.objectId,
        entityTypeId: this.$route.params.entityTypeId,
        entities: this.$route.params.entities
      };
      const query = {
        templates,
        uploads
      };
      // console.log(params);
      this.$router.push({
        name: "document",
        params,
        query
      });
    },
    toggleTemplate(template) {
      this.selectedTemplates = this.selectedTemplates.includes(template.id)
        ? this.selectedTemplates.filter((u) => u != template.id)
        : [...this.selectedTemplates, template.id];
    },
    toggleUpload(upload) {
      this.selectedUploads = this.selectedUploads.includes(upload.id)
        ? this.selectedUploads.filter((u) => u != upload.id)
        : [...this.selectedUploads, upload.id];
    }
  },
  created() {
    this.fetchTemplates();
    this.fetchEntities();
    this.fetchFile();
  }
};
</script>

<style scoped>
.entities a {
  margin-right: 10px;
}
</style>
